/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Components/ToggleDisabledServiceEndpointConfirmationDialog" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Details/Resources";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { TitleSize } from "VSSUI/Header";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export interface IToggleDisabledServiceEndpointConfirmationDialogProps {
    primaryOnClick: () => void;
    onDismiss: () => void;
    onBackNavigation: () => void;
    serviceEndpoint: ServiceEndpoint;
}

export class ToggleDisabledServiceEndpointConfirmationDialog extends VssComponent<IToggleDisabledServiceEndpointConfirmationDialogProps, {}> {
    constructor(props: IToggleDisabledServiceEndpointConfirmationDialogProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        const isDisabled = this.props.serviceEndpoint.isDisabled;
        const submitText = isDisabled ? Resources.EnablePrimaryButtonText : Resources.DisablePrimaryButtonText;
        const titleText = isDisabled ? Resources.EnableDisabledServiceEndpointConfirmationTitle : Resources.DisableEnabledServiceEndpointConfirmationTitle;
        const dialogText = isDisabled ? Resources.EnableDisabledServiceEndpointConfirmationDialogMessage : Resources.DisableEnabledServiceEndpointConfirmationDialogMessage;
        return (
            <Dialog
                titleProps={{
                    text: titleText,
                    size: TitleSize.Large
                }}
                onDismiss={() => {
                    this.props.onDismiss();
                }}
                footerButtonProps={[
                    {
                        text: Resources.Cancel,
                        onClick: () => {
                            this.props.onDismiss();
                        }
                    },
                    {
                        text: submitText,
                        primary: true,
                        onClick: () => {
                            this.props.primaryOnClick();
                        }
                    }
                ]}
            >
                <div>{dialogText}</div>
            </Dialog>
        );
    }
}
